import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabfare() {



const cardData = {
  keyword: " Pune Cab fare ",

"headingDescription": "Pune Cab Fare service offers affordable, transparent, and reliable pricing for local and outstation travel across Pune. Whether you need a cab for city rides, airport transfers, business travel, or sightseeing, SRS Cab Service ensures competitive fares with no hidden charges. With professional drivers, well-maintained vehicles, and flexible booking options, Pune Cab Fare service provides a smooth and budget-friendly travel experience for every passenger.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and one of Pune’s most iconic landmarks. Travelers using Pune Cab Fare services often visit this site to explore its grand architecture and learn about the city’s Maratha history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant historical monument linked to India’s freedom movement. Visitors booking Pune Cab Fare rides can explore its beautiful gardens and museum showcasing important events."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort known for trekking and scenic views. Travelers using Pune Cab Fare services often visit this destination to enjoy nature and historical surroundings."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of the most famous temples in Pune. Devotees using Pune Cab Fare services frequently visit this temple to seek blessings and experience spiritual peace."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Visitors using Pune Cab Fare services can explore this peaceful site located in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts and art. Travelers using Pune Cab Fare rides often explore this museum to experience Pune’s cultural heritage."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Visitors booking Pune Cab Fare services often climb the hill to enjoy scenic beauty and spirituality."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful getaway near Pune known for its scenic surroundings. Travelers using Pune Cab Fare services often relax here and enjoy nature away from city crowds."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden. Visitors using Pune Cab Fare services enjoy walking through its greenery and calm atmosphere."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Travelers using Pune Cab Fare services visit this site to explore Pune’s rich historical background."
  }
],



services: [
{
name: "Pune Cab Fare",
description: "Pune cab fare service provides clear and transparent pricing for local and outstation travel. Customers can check estimated fares before booking rides. Affordable pricing ensures budget-friendly transportation. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Travel confidently with Pune cab fare services."
},
{
name: "Pune Taxi Rates",
description: "Pune taxi rates offer detailed pricing for city and long-distance travel. Customers can compare rates before booking taxis. Affordable pricing ensures cost-effective journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose taxi services with clear rates in Pune."
},
{
name: "Pune Cab Charges",
description: "Pune cab charges provide transparent pricing details for travelers. Customers can check fare estimates before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Choose cab services with clear charges in Pune."
},
{
name: "Pune Taxi Fare in Affordable Price",
description: "Pune taxi fare in affordable price offers budget-friendly travel options for all passengers. Customers can book taxis at economical rates. Professional drivers ensure safe and smooth journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures no hidden charges. Travel affordably with Pune taxi services."
},
{
name: "Pune Cab Pricing",
description: "Pune cab pricing service provides detailed cost breakdown for travelers. Customers can estimate travel expenses before booking rides. Affordable pricing ensures cost-effective journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose cab services with transparent pricing in Pune."
},
{
name: "Pune Cab Tariff",
description: "Pune cab tariff offers structured pricing for local and outstation rides. Customers can check per km rates and packages. Affordable tariffs ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Choose cab services with clear tariff plans."
},
{
name: "Pune Taxi Fare Estimate",
description: "Pune taxi fare estimate provides approximate pricing for trip planning. Customers can calculate fares before booking taxis. Affordable estimates ensure better travel budgeting. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with taxi fare estimates in Pune."
},
{
name: "Pune Cab Rate Card",
description: "Pune cab rate card provides complete pricing details for different vehicle types. Customers can check rates for sedan, SUV, and luxury cars. Transparent pricing ensures fair fares. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose cab services with detailed rate cards in Pune."
},
{
name: "Pune to Shirdi Cab Fare",
description: "Pune to Shirdi cab fare offers clear pricing for pilgrimage travel. Customers can check fare details before booking rides. Affordable pricing ensures budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily from Pune to Shirdi with cab fare services."
},
{
name: "Pune to Shirdi Taxi Fare",
description: "Pune to Shirdi taxi fare provides estimated pricing for temple visits. Customers can compare fares before booking taxis. Affordable rates ensure cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Choose taxi services with transparent fare for Shirdi travel."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai airport cab fare service provides pricing for airport transfers. Customers can check fare estimates before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure timely journeys. Comfortable vehicles enhance experience. Travel easily to Mumbai Airport with cab fare services."
},
{
name: "Mumbai Pune Taxi Fare",
description: "Mumbai Pune taxi fare offers clear pricing for intercity travel. Customers can compare rates before booking rides. Affordable pricing ensures cost-effective journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose taxi services with transparent fare between Mumbai and Pune."
},
{
name: "Pune to Mumbai Cab Fare",
description: "Pune to Mumbai cab fare provides pricing details for expressway travel. Customers can check fares before booking rides. Affordable pricing ensures budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily from Pune to Mumbai with cab fare services."
},
{
name: "Pune to Mumbai Cab Charges",
description: "Pune to Mumbai cab charges provide transparent pricing for intercity travel. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with clear charges for Mumbai trips."
},
{
name: "Pune to Bhimashankar Taxi Fare",
description: "Pune to Bhimashankar taxi fare offers pricing for pilgrimage travel. Customers can check fare estimates before booking rides. Affordable rates ensure budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily to Bhimashankar with taxi fare services."
},
{
name: "Mumbai Airport to Pune Taxi Fare",
description: "Mumbai airport to Pune taxi fare provides clear pricing for airport transfers. Customers can check fare details before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily from Mumbai Airport to Pune."
},
{
name: "Pune Mumbai Taxi Fare",
description: "Pune Mumbai taxi fare offers detailed pricing for intercity travel. Customers can compare fares before booking rides. Affordable rates ensure budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Choose taxi services with transparent fare for Pune Mumbai travel."
},
{
name: "Pune to Bhimashankar Cab Fare",
description: "Pune to Bhimashankar cab fare provides pricing details for temple travel. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily with cab fare services to Bhimashankar."
},
{
name: "Pune to Mahabaleshwar Distance by Taxi Fare",
description: "Pune to Mahabaleshwar distance by taxi fare offers cost estimates based on travel distance. Customers can plan trips with clear pricing details. Affordable fares ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with taxi fare estimates."
},
{
name: "Pune to Goa Taxi Fare",
description: "Pune to Goa taxi fare provides pricing for long-distance coastal travel. Customers can check fare estimates before booking rides. Affordable rates ensure cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily from Pune to Goa with taxi fare services."
},
{
name: "Pune to Trimbakeshwar Cab Fare",
description: "Pune to Trimbakeshwar cab fare offers pricing details for pilgrimage travel. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily with cab fare services to Trimbakeshwar."
},
{
name: "Pune to Aurangabad Taxi Fare",
description: "Pune to Aurangabad taxi fare provides cost estimates for historical travel routes. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily from Pune to Aurangabad with taxi fare services."
},
{
name: "Pune Airport to Shirdi Distance Taxi Fare",
description: "Pune airport to Shirdi distance taxi fare offers pricing based on travel distance. Customers can check fare details before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily from Pune Airport to Shirdi with taxi fare services."
}
],

tableData: [
["Pune Cab Fare","Pune Taxi Rates"],
["Pune Cab Charges","Pune Taxi Fare in Affordable Price"],
["Pune Cab Pricing","Pune Cab Tariff"],
["Pune Taxi Fare Estimate","Pune Cab Rate Card"],
["Pune to Shirdi Cab Fare","Pune to Shirdi Taxi Fare"],
["Pune to Mumbai Airport Cab Fare","Mumbai Pune Taxi Fare"],
["Pune to Mumbai Cab Fare","Pune to Mumbai Cab Charges"],
["Pune to Bhimashankar Taxi Fare","Mumbai Airport to Pune Taxi Fare"],
["Pune Mumbai Taxi Fare","Pune to Bhimashankar Cab Fare"],
["Pune to Mahabaleshwar Distance by Taxi Fare","Pune to Goa Taxi Fare"],
["Pune to Trimbakeshwar Cab Fare","Pune to Aurangabad Taxi Fare"],
["Pune Airport to Shirdi Distance Taxi Fare","Pune Cab Fare"]
],



whychoose: [
  {
    WhyChooseheading: "Affordable Pune Cab Fare",
    WhyChoosedescription: "SRS Cab Service offers competitive Pune cab fare with budget-friendly pricing. Our rates are designed to provide maximum value for money for local rides, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and transparent Pune cab fare details including per km rates, tolls, and driver allowance. Customers are informed of the total cost before booking."
  },
  {
    WhyChooseheading: "Best Per KM Cab Rates in Pune",
    WhyChoosedescription: "SRS Cab Service offers economical per km pricing starting from affordable rates for hatchbacks, sedans, and SUVs, making travel cost-effective for all customers."
  },
  {
    WhyChooseheading: "Flexible Fare Options for Every Travel Need",
    WhyChoosedescription: "We provide multiple fare options including per km pricing, hourly packages, full-day rentals, and fixed route pricing for Pune city and outstation travel."
  },
  {
    WhyChooseheading: "24/7 Cab Service at Fixed Fare",
    WhyChoosedescription: "Our Pune cab fare remains reasonable even during late-night and early morning bookings, ensuring reliable and affordable service at any time."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles at Different Price Points",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, and premium Innova Crysta with fare options suitable for every budget and requirement."
  },
  {
    WhyChooseheading: "All-Inclusive Outstation Fare Options",
    WhyChoosedescription: "For outstation travel, we provide all-inclusive Pune cab fare packages covering fuel, tolls, and driver charges for a hassle-free journey."
  },
  {
    WhyChooseheading: "Trusted & Cost-Effective Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for offering fair and affordable Pune cab fare with reliable service, ensuring customer satisfaction for every ride."
  }
]
}

const faqData = [
  { question: "What is the cab fare per km in Pune?", answer: "Pune cab fare typically starts from around ₹9 to ₹15 per km for hatchback and sedan cars, depending on the service and vehicle type." },
  { question: "What is the starting fare for taxi in Pune?", answer: "Taxi fares in Pune usually include a base fare plus per km charges, with starting fares around ₹50 and per km charges varying based on the cab type." },
  { question: "Is Pune cab fare fixed or variable?", answer: "Cab fare can be fixed for outstation routes or calculated per km for local travel depending on the booking type." },
  { question: "Do cab fares include toll charges?", answer: "For outstation travel, toll charges are usually included or clearly mentioned in the fare breakdown." },
  { question: "Are night charges applicable in Pune cab fare?", answer: "Yes, some cab services may apply additional night charges depending on timing and service provider." },
  { question: "Which is the cheapest cab option in Pune?", answer: "Hatchback and sedan cars usually offer the lowest fare options starting from economical per km rates." },
  { question: "How is outstation cab fare calculated?", answer: "Outstation cab fare is calculated based on per km rate, minimum km/day, driver allowance, and toll charges." },
  { question: "Do you provide hourly cab packages in Pune?", answer: "Yes, SRS Cab Service offers hourly and full-day packages like 4 hrs/40 km and 8 hrs/80 km plans." },
  { question: "Can I get fixed fare for Pune to Mumbai cab?", answer: "Yes, many routes like Pune to Mumbai have fixed fare packages starting from around ₹1900 depending on the vehicle." },
  { question: "Is online fare estimation available?", answer: "Yes, you can get fare estimates online before booking your cab." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash More",
    feedback:
      "SRS Cab Service offers very reasonable Pune cab fare. Pricing was clear and no hidden charges at all.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Kulkarni",
    feedback:
      "Affordable cab service in Pune with transparent pricing. Best option for daily and airport travel.",
    rating: 5
  }
];

































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Cab Fare | SRS Cab",
  "description": "SRS Cab provides Pune cab fare information including taxi rates, cab charges, and fare estimates for popular routes such as Pune to Shirdi, Pune to Mumbai Airport, Pune to Bhimashankar, Pune to Mahabaleshwar, Pune to Goa, Pune to Trimbakeshwar, Pune to Aurangabad, and more. Affordable, transparent pricing with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune Cab Fare | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Check Pune cab fares with SRS Cab. Taxi rates, cab charges, and fare estimates for routes like Pune to Shirdi, Mumbai Airport, Bhimashankar, Mahabaleshwar, Goa, Trimbakeshwar, and Aurangabad. Affordable pricing with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punecabfare;